export const setIsLoading = (isLoading) => {
  return {
    type: "SET_IS_LOADING",
    payload: isLoading,
  };
};

export const setChangingTeam = (changeTeam) => {
  return {
    type: "SET_CHANGING_TEAM",
    payload: changeTeam,
  };
};
